import React, { FC } from 'react'
import { FormControl, Select, MenuItem, SelectProps } from '@mui/material'

type PixelSingleSelectOptions = {
    [key: string]: string
}
export interface PixelSingleSelectProps {
    widthPX?: number
    heightPX: number
    options: PixelSingleSelectOptions
    onChange: SelectProps['onChange']
    value: SelectProps['value']
    placeholder: string
    selectProps: SelectProps
    showPlaceHolder?: (value: SelectProps['value']) => boolean
    autoWidth?: boolean
    hasError?: boolean
}
const PixelSingleSelect: FC<PixelSingleSelectProps> = (props) => {
    const array = Object.entries(props.options)
    return (
        <FormControl 
            size="small" 
            error={props.hasError}
            fullWidth={props.autoWidth} 
            disabled={props.selectProps.disabled}
            sx={{ m: 1, width: props.widthPX, height: props.heightPX, margin: '0px 8px' }} 
        >
            <Select
                autoWidth
                displayEmpty
                value={props.value}
                className={`${props.hasError ? 'mui-select-error ' : ' '}`}
                onChange={props.onChange}
                renderValue={(selected: keyof PixelSingleSelectOptions) => {
                    if (props.showPlaceHolder) {
                        if(props.showPlaceHolder(selected)) {
                            return props.placeholder
                        } else {
                            return props.options[selected]
                        }
                    } 

                    if (selected === "") {
                        return props.placeholder
                    }
        
                    return props.options[selected]
                }}
                {...props.selectProps}
            >
                { array.map(([key, value]) => 
                    <MenuItem key={key} value={key} sx={{ width: props.widthPX, fontSize: '15px' }}>{value}</MenuItem>
                )}
            </Select>
        </FormControl>
    )
}

export default PixelSingleSelect